import { useState, useEffect, useCallback } from "react";
import { getAllNews, getNewsBySlug } from "@/api/newsApi";

export const useNews = (slug) => {
  const [news, setNews] = useState([]);
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAllNews = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getAllNews();
      setNews(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchNewsBySlug = useCallback(async (newsSlug) => {
    try {
      setLoading(true);
      const data = await getNewsBySlug(newsSlug);
      setArticle(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (slug) {
      fetchNewsBySlug(slug);
    } else {
      fetchAllNews();
    }
  }, [slug, fetchAllNews, fetchNewsBySlug]);

  return { news, article, loading, error, fetchAllNews, fetchNewsBySlug };
};
